import { format, isToday, isTomorrow, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale/pt-BR'

/**
 * @example
 * getDisplayDate('2027-01-08') // '8 jan 2027'
 */
export function getDisplayDate(date: string): string {
  return format(parseISO(date), 'd MMM yyyy', { locale: ptBR })
}

/**
 * @example
 * getRelativeDisplayDate('2027-01-08') // '8 jan 2027'
 * getRelativeDisplayDate(today) // 'Hoje, 8 jan 2027'
 */
export function getRelativeDisplayDate(date: string): string {
  const parsedDate = parseISO(date)

  if (isToday(parsedDate)) return `Hoje, ${getDisplayDate(date)}`
  if (isTomorrow(parsedDate)) return `Amanhã, ${getDisplayDate(date)}`

  return getDisplayDate(date)
}
